"use client";

import { Link } from "@/navigation";
import { capturePostHogEvent } from "@/lib/posthog";

interface EventCardLinkProps {
  href: string;
  slug: string;
  children: React.ReactNode;
  className?: string;
}

export function EventCardLink({ href, slug, children, className }: EventCardLinkProps) {
  return (
    <Link
      href={href as any}
      onClick={() => capturePostHogEvent("event_card_clicked", { event_slug: slug })}
      className={className}
    >
      {children}
    </Link>
  );
}
